export const DAPP_NAME = "Land Block Sale";
export const MADE_BY = "by Superrisk Studio";